export const checkImageLoaded = (url: string, callback: (boolean) => void) => {
  const img = new Image()
  img.src = url

  img.onload = () => {
    callback(true)
  }

  img.onerror = () => {
    callback(false)
  }
}
